import axiosInstance from "../axios";

const PREFIX = "/Products";

export const GetProductByName = (body) => {
  return axiosInstance.post(`${PREFIX}/GetProductByName`, {
    ...body,
  });
};

export const GetAllMobilesWithFilters = (body) => {
  return axiosInstance.post(`${PREFIX}/GetAllMobilesWithFilters`, body);
};

export const GetProductById = (body) => {
  return axiosInstance.post(`${PREFIX}/GetProductById`, {
    ...body,
  });
};

export const GetAccessoryById = (body) => {
  return axiosInstance.post(`${PREFIX}/GetAccessoryById`, {
    ...body,
  });
};

export const GetAllAccessoriesWithFilters = (body) => {
  return axiosInstance.post(`${PREFIX}/GetAllAccessoriesWithFilters`, {
    ...body,
  });
};

export const GetProductByCategory = (body) => {
  return axiosInstance.post(`${PREFIX}/GetProductByCategory`, {
    ...body,
  });
};

export const GetAllBanner = () => {
  return axiosInstance.get(`${PREFIX}/GetBanners`);
};

export const CreateInstallmentTemporary = (body) => {
  return axiosInstance.post(`${PREFIX}/CreateInstallmentTemporary`, body);
};
